import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { HeaderComponent } from './header.component';
import { LangSwitcherModule } from '../lang-switcher/lang-switcher.module';
import { AngularFireStorage } from '@angular/fire/compat/storage';

import { HeaderMenuModule } from '../header-menu/header-menu.module';
import { HomeContactFormModule } from '../home-interested-form/home-interested-form.module';

@NgModule({
    imports: [
        CommonModule,
        TranslateModule,
        LangSwitcherModule,
        HomeContactFormModule,
        HeaderMenuModule
    ],
    providers: [
        AngularFireStorage
    ],
    declarations: [
        HeaderComponent
    ],
    exports: [
        HeaderComponent
    ]
})
export class HeaderModule { }
